import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react"; // ArrowLeft ഒഴിവാക്കി, കാരണം അത് ഇനി Navbar-ൽ ആണ്

// 🔥 IMPORT SHARE BUTTON
import ShareButton from "../components/ShareButton";
import { Helmet } from 'react-helmet-async';
// 🔥 IMPORT IMAGES
import Madayipara from "../images/Madayipara Payangadi Live.webp";
import Madaikotta from "../images/Madayikkotta Payangadi Live.webp";
import Madaipalli from "../images/Madayippalli Payangadi Live.webp";
import Vadukunda from "../images/Vadukunda Temple Payangadi Live.webp";
import Jewpond from "../images/Joothakkulam Payangadi Live.webp";
import Kakki from "../images/kakkithodu.jpg";
import Vayalapra from "../images/Vayalapra Parappu Payangadi Live.webp";
import Chootad from "../images/Choottad Beach Payangadi Live.webp";
import Mattul from "../images/mattolbecah.webp";
import Madaikavu from "../images/madayikavu.jpg";
import Riverview from "../images/Payangadi Reverview Park.webp";

export default function TourismDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const places = [
    {
      id: "madaipara",
      name: "മാടായിപ്പാറ",
      location: "Madai, Kannur",
      image: Madayipara,
      fullDesc: `കണ്ണൂർ ജില്ലയിലെ മാടായി ഗ്രാമപഞ്ചായത്തിൽ സ്ഥിതി ചെയ്യുന്ന കുന്നിൻ പ്രദേശമാണ് മാടായിപ്പാറ. അറുന്നൂറേക്കളോളം പരന്നു കിടക്കുന്ന ഈ സ്ഥലം പ്രകൃതിഭംഗിയാലും ജൈവവൈവിധ്യങ്ങളാലും സമ്പന്നമാണ്.

HISTORY:
പ്രാക്തന കാലം തൊട്ട് നാവികർക്ക് വഴികാട്ടിയായ ഏഴിമലയ്ക്ക് തൊട്ടു കിഴക്കാണ് മാടായിപ്പാറ. ഒരു കാലത്ത് ഇവിടം മുഴുവൻ വെള്ളത്തിനടിയിലായിരുന്നു. ഏഴിമലയ്ക്ക് നാല് ചുറ്റും കടലായിരുന്നു എന്ന് കേരളോൽപ്പത്തിയിൽ പരാമർശമുണ്ട്. വെള്ളം നീങ്ങി ഉയർന്നുവന്ന കരഭാഗത്തിന് മാട് എന്ന് പേരുണ്ട്. അങ്ങനെ മാട് ആയ സ്ഥലമാണ് മാടായി എന്ന് പിന്നീട് അറിയപ്പെട്ടത്. കോലത്തുനാട്ടിലെ രാജാവായ ഉദയവർമന്റെ ആസ്ഥാനമായിരുന്നു ഇവിടം. കോലത്തുരാജാവിന്റെ സദസ്യനായിരുന്ന ചെറുശ്ശേരി ഇവിടെയാണു് ജീവിച്ചിരുന്നതെന്ന് പറയപ്പെടുന്നു. മാടായിപ്പാറ ഉൾപ്പെടുന്ന പ്രദേശം മുമ്പ് പോർച്ചുഗീസുകാരുടെ അധീനതയിലായിരുന്നു. മാടായിപ്പാറയിലെ പാളയം മൈതാനത്ത് ടിപ്പുവിന്റെ പടയോട്ടക്കാലത്ത്‌ യുദ്ധം നടന്നിരുന്നു.

NATURE:
മാടായിപ്പാറയുടെ പടിഞ്ഞാറ് വശത്ത് ഏഴിമലയാണ്‌. ഏഴിമലക്ക് മുകളിലൂടെയുള്ള സൂര്യാസ്തമയം മാടായിപ്പാറയിലെ ഏറെ ആകർഷകമായ ഒരു കാഴ്ചയാണ്. പാറയുടെ തെക്ക് കിഴക്ക് ഭാഗത്തൂടെ ഒഴുകുന്ന പഴയങ്ങാടിപ്പുഴ മറ്റൊരു മനോഹരകാഴ്ചയാണ്. തീവ്രമായ മഴക്കാലവും നന്നേ വരണ്ട വേനലും ഇവിടത്തെ കാലാവസ്ഥയുടെ പ്രത്യേകതയാണ്. വേനൽകാലത്തു് പാറയിലെ പുല്ലുകൾ കരിഞ്ഞുതുടങ്ങുകയും പലപ്പോഴും തീപിടിത്തമുണ്ടാകുകയും ചെയ്യും. പോർച്ചുഗീസുകാർ 'ലാൻഡ്‌ ഓഫ്‌ ബർണിങ്‌ ഫയർ' എന്നു വിളിച്ചിതിൽ നിന്നാണ് കിഴക്കു ഭാഗത്തിനു് 'എരിയുന്ന പുരം' എന്നർത്ഥം വരുന്ന എരിപുരം എന്ന സ്ഥലപേരുണ്ടായത്.

BIODIVERSITY:
അപൂർവം സസ്യ-ജന്തുജാലങ്ങളുള്ള ഒരു കലവറ തന്നെയാണു് മാടായിപ്പാറ. 38 ഇനം പുൽച്ചെടികളും, 500 ഓളം തരത്തിലുള്ള മറ്റു ചെടികളും ഇവിടെ വളരുന്നു. ഇതിൽ 24 ഇനം ഔഷധചെടികളാണ്. അപൂർവ്വങ്ങളായ 92 ഇനം ചിത്രശലഭങ്ങളും 175 ഓളം പക്ഷികളും ഈ പ്രദേശത്ത് കാണപ്പെടുന്നു.`
    },
    {
      id: "madaikotta",
      name: "മാടായിക്കോട്ട",
      location: "Madai",
      image: Madaikotta,
      fullDesc: `മാടായിപ്പാറക്ക് മുകളിൽ തെക്കേയറ്റത്തായി സ്ഥിതിചെയ്യുന്ന ഒരു പുരാതന കോട്ടയാണ് മാടായിക്കോട്ട. തെക്കിനാക്കീൽ കോട്ട എന്നും ഇത് അറിയപ്പെടുന്നുണ്ട്.

2000 വർഷം മുമ്പ് മൂഷകവംശത്തിലെ ഭല്ലവൻ രാജാവ് പണികഴിപ്പിച്ചതാണ് മാടായിപ്പാറയിലെ ഈ കോട്ട. 1765-68 കാലഘട്ടത്തിൽ ഹൈദരലിയുടെയും കോലത്തുരാജാവിന്റെയും സൈന്യങ്ങൾ ഏറ്റുമുട്ടിയത്‌ ഇതിന് സമീപമുള്ള പാളയം ഗ്രൗണ്ടിലാണ്‌.

അനേകം യുദ്ധങ്ങൾക്കും ചരിത്രസംഭവങ്ങൾക്കും സാക്ഷ്യം വഹിച്ച കോട്ട പിന്നീട് തകരുകയായിരുന്നു. വടക്കൻ കേരളത്തിലെ കോട്ടകൾ പുതുക്കിപ്പണിയാനായി പുരാവസ്തു വകുപ്പ് തീരുമാനിച്ച പ്രകാരം 2010ൽ കോട്ടയുടെ ചില ഭാഗങ്ങൾ പുനരുദ്ധരിക്കുകയുണ്ടായി. കോട്ടയുടെ ഭാഗങ്ങൾ മാത്രമാണ് കല്ലുകെട്ടി നവീകരിച്ചിട്ടുള്ളത്.`
    },
    {
      id: "madaipalli",
      name: "മാടായി പള്ളി",
      location: "Madai",
      image: Madaipalli,
      fullDesc: `പാറയുടെ പഴയങ്ങാടി ഭാഗത്തെ ചരിവിലാണ്‌ 12-ാം നൂറ്റാണ്ടിൽ പണികഴിപ്പിച്ച പ്രസിദ്ധമായ മാടായിപ്പള്ളി. 

മാടായിപ്പള്ളി കേരളത്തിൽ നിർമിക്കപ്പെട്ട മൂന്നാമത്തെ മുസ്ലിം പള്ളിയാണ്. ഈ പള്ളിയിലെ ഒരു വെളുത്ത മാർബിൾ പാളി മെക്കയിൽ‍ നിന്നും മാലിക് ഇബിൻ ദിനാർ കൊണ്ടുവന്നത് ആണെന്നാണ് വിശ്വാസം. പ്രവാചകന്റെ വചനം പ്രചരിപ്പിക്കുവാനായി ഇന്ത്യയിൽ എത്തിയതായിരുന്നത്രെ മുഹമ്മദ് നബിയുടെ ശിഷ്യനായ മാലിക് ഇബിൻ ദിനാർ.`
    },
    {
      id: "vadukunda",
      name: "വടുകുന്ദ ശിവക്ഷേത്രം",
      location: "Madai",
      image: Vadukunda,
      fullDesc: `കണ്ണൂർ ജില്ലയിലെ മാടായി ഗ്രാമത്തിൽ ഉള്ള മാടായിപ്പാറ എന്ന പീഠഭൂമിക്കു മുകളിലാണ് ഈ ക്ഷേത്രം സ്ഥിതിചെയ്യുന്നത്. 

മാടായി വടുകുന്ദ ശിവക്ഷേത്രം നിർമ്മിച്ചത് കോലത്തിരി രാജാക്കന്മാരാണെന്ന് കരുതപ്പെടുന്നു. മദ്ധ്യകാലഘട്ടത്തിലാണ് ഈ ക്ഷേത്രത്തിന്റെ നിർമ്മാണം. 8-ആം നൂറ്റാണ്ടിൽ ഏഴിമല ഭരിച്ചിരുന്ന മൂഷിക സാമ്രാജ്യത്തിന്റെ ഒരു ശാഖയായിരുന്നു കോലത്തിരി രാജ്യം. ഏകദേശം 1200 വർഷങ്ങൾക്കു മുൻപ് ഈ രാജവംശത്തിന്റെ ഒരു ശാഖ മാടായിയിലേക്ക് കുടിയേറിപ്പാർത്തു. 

കടൽ നിരപ്പിൽ നിന്നും 150 അടി പൊക്കമുള്ള പീഠഭൂമിയായ മാടായിപ്പാറയിൽ ഇവർ കോട്ടകളും ക്ഷേത്രങ്ങളും നിർമ്മിച്ചു. ഇവിടെ നിന്ന് 20 കിലോമീറ്റർ ചുറ്റളവിലുള്ള എല്ലാ സ്ഥലങ്ങളും കാണാൻ കഴിയുമെന്നത് ആയിരിക്കും ഈ സ്ഥലം തിരഞ്ഞെടുക്കുവാനുള്ള കാരണം. മാടായിപ്പാറയുടെ തെക്കു-വടക്ക് മൂലയിൽ സ്വയംഭൂവായി വന്ന ശിവലിംഗം കണ്ട് ഇവിടെ ശ്രീ വടുകുണ്ട ശിവക്ഷേത്രം നിർമ്മിച്ചു എന്നാണ് വിശ്വാസം.`
    },
    {
      id: "jewpond",
      name: "ജൂതക്കുളം",
      location: "Madai",
      image: Jewpond,
      fullDesc: `മാടായിപ്പാറയിൽ ഏതു വേനലിലും വറ്റാത്ത കുളങ്ങളുണ്ട്‌. പാറക്കുളം എന്നാണവ പൊതുവേ അറിയപ്പെടുന്നതു്. അത് പണ്ട് ജൂതർ പണിതതിനാൽ ജൂതക്കുളമെന്നും അറിയപ്പെടുന്നു.

കേരളത്തിലെ ജൂത സംസ്കാരത്തിന്റെ നിലനിൽക്കുന്ന അപൂർവം തെളിവുകളിലൊന്നാണ് മാടായിപ്പാറയിലെ ജൂതക്കുളം. മാടായിപ്പള്ളി നിർമിച്ച മാലിക് ദിനാർ ഇവിടെ വന്നപ്പോൾ ജൂതർ ഇവിടെ ഉണ്ടായിരുന്നു എന്ന് കരുതപ്പെടുന്നു. ഭാരതത്തിൽ ആദ്യമായി ജൂത കുടിയേറ്റം നടന്നത് ഇവിടെയാണ്.`
    },
    {
      id: "kakki",
      name: "കക്കി തോട്",
      location: "Madai",
      image: Kakki,
      fullDesc: `കക്കി തോട് എന്ന് ഓമനപേരിട്ടു വിളിക്കുന്ന ഈ ചെറുവെള്ളച്ചാട്ടം മാടായിപാറയിൽ തെക്ക് പടിഞ്ഞാറുമാറി വടുകുന്ദക്ഷേത്രത്തിന്റെ തെക്ക് ഭാഗത്തായി ആണ് സ്ഥിതിചെയ്യുന്നത്.

മഴക്കാലത്ത് അതും തുടർച്ചയായി മഴ പെയ്താൽ മാത്രമേ ഇവിടെ നല്ല ഒഴുക്ക് ഉണ്ടാവുകയുള്ളൂ. പാറയുടെ ചെരുവിൽ സ്ഥിതിചെയ്യുന്നതിനാൽ പുറമെനിന്ന് നോക്കുമ്പോൾ അതിനെ മറച്ച കാട് മാത്രമേ കാണാൻ ആവുകയുള്ളൂ. വള്ളികളും പാറകളും മരങ്ങളും കുറ്റിചെടികളും നിറഞ്ഞ് ഇരുണ്ട്മൂടിയ കുത്തനെയുള്ള ഇറക്കമാണ്. മാടായിപാറയിൽ നിന്നുള്ള വെള്ളം ഇതിലൂടെ ഒഴുകി താഴേക്ക് പതിച്ച് മാടായിലൂടെ ഒഴുകി സുൽത്താൻ തോടിൽ വന്നെത്തും.`
    },
    {
      id: "vayalapra",
      name: "വയലപ്ര പരപ്പ്",
      location: "Pazhayangadi",
      image: Vayalapra,
      fullDesc: `പഴയങ്ങാടിയിൽ നിന്നും ഏകദേശം 6 കി.മീ ദൂരെയാണ് ചെമ്പല്ലിക്കുണ്ട്. അവിടെയാണ് വയലപ്ര പരപ്പ് സ്ഥിതി ചെയ്യുന്നത്.

പെരുമ്പപ്പുഴയുടെ ഈ തീരം ഒരു പ്രകൃതിദത്ത പക്ഷി സങ്കേതമാണ്. വർഷം തോറും ആയിരക്കണക്കിന് ദേശാടനപ്പക്ഷികളെയാണ് ഈ ചതുപ്പ് പ്രദേശം ആകർഷിക്കുന്നത്.`
    },
    {
      id: "chootad",
      name: "ചൂട്ടാട് ബീച്ച്",
      location: "Kannur",
      image: Chootad,
      fullDesc: `പഴയങ്ങാടിയിൽ നിന്നും 5 കി. മീ ദൂരെ സ്ഥിതി ചെയ്യുന്ന ബീച്ചാണ് ഇത്. 

ബീച്ച് പാർക് ആണ് ഇപ്പോൾ ഇവിടുത്തെ മുഖ്യ ആകർഷണം. ചൂട്ടാട് ബീച്ച് ഒരു അഴിമുഖപ്രദേശം കൂടിയാണ്.`
    },
    {
      id: "mattul",
      name: "മാട്ടൂൽ ബീച്ച്",
      location: "Ezhimala",
      image: Mattul,
      fullDesc: `ഏഴിമലയ്ക്ക് സമീപമാണ് മാട്ടൂൽ ബീച്ച് സ്ഥിതിചെയ്യുന്നത്. ചൂട്ടാട് ബീച്ച് ഇതിന്റെ ഭാഗമാണ്.`
    },
    {
      id: "madaikavu",
      name: "മാടായി കാവ്",
      location: "Madai",
      image: Madaikavu,
      fullDesc: `വടക്കേ മലബാറിലെ ശാക്തേയ ആരാധനാകേന്ദ്രങ്ങളിൽ പ്രധാനമായ മാടായിക്കാവ് സ്ഥിതിചെയ്യുന്നത് മാടായിപ്പാറയിലാണ്. ചിറയ്ക്കൽ കോവിലകത്തിന്റെ പരദേവതയാണ് മാടായിക്കാവിലമ്മ. 

കേരളത്തിലെ ആദ്യത്തെ ഭദ്രകാളിക്ഷേത്രം കൊടുങ്ങല്ലൂരും രണ്ടാമത്തെ ഭദ്രകാളിക്ഷേത്രം മാടായിയിലുമാണെന്നാണ് പുരാവൃത്തം. മത്സ്യ മാംസങ്ങൾ ഭക്ഷിക്കുന്ന ഒറിയ ബ്രാഹ്മണരാണ് മാടായിക്കാവിൽ പൂജ നടത്തുന്നത്‌. പുലയരുടെ ദൈവമായ കാരിഗുരുക്കൾ പുലിവേഷം മറിഞ്ഞ്‌ ദൈവക്കരുവായ കഥ തുടങ്ങുന്നത്‌ മാടായിക്കാവിലാണ്‌. മാടായിക്കാവിലെ പൂരംകുളി ഉത്സവം ചരിത്രപ്രാധാന്യമുള്ളതാണ്. പ്രകൃതിയുമായി ബന്ധപ്പെടുത്തിയതാണ്‌ മാടായിക്കാവിലെ ആരാധനാക്രമം.`
    },
    {
      id: "riverview",
      name: "റിവർ വ്യൂ പാർക്ക്",
      location: "Pazhayangadi",
      image: Riverview,
      fullDesc: `പഴയങ്ങാടി - മുട്ടുകണ്ടിറോഡില്‍ 90 ലക്ഷം രൂപ ഉപയോഗിച്ച്‌ നിര്‍മ്മിച്ചതാണ് പഴയങ്ങാടി റിവര്‍ വ്യൂ പാര്‍ക്ക്.

പദ്ധതിയുടെ ഭാഗമായി ഇരിപ്പിടങ്ങളും ലൈറ്റുകളും ഇവിടെ ഒരുക്കിയിട്ടുണ്ട്. രാത്രികാലങ്ങളിലും സഞ്ചാരികൾ ഇവിടെ പതിവാണ്. എങ്കിലും റോഡരികിലുള്ള മാലിന്യനിക്ഷേപങ്ങൾക്ക് പഴയതിൽ നിന്ന് യാതൊരുമാറ്റവും സംഭവിച്ചിട്ടില്ല.`
    }
  ];

  const place = places.find((p) => p.id === id);

  if (!place) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800">Place Not Found</h2>
          <button 
            onClick={() => navigate("/tourism")}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <><Helmet>
        <title>{place.name} | Info Payangadi</title>
        <meta name="description" content={`${place.name}-നെ കുറിച്ചുള്ള ചരിത്രവും വിവരങ്ങളും.`} />
        
        {/* 🔥 OPEN GRAPH TAGS 🔥 */}
        <meta property="og:title" content={`${place.name} - Info Payangadi`} />
        <meta property="og:description" content={`${place.name}-നെ കുറിച്ചുള്ള കൂടുതൽ വിവരങ്ങൾ വായിക്കാം.`} />
        <meta property="og:image" content={window.location.origin + place.image} /> {/* സ്ഥലത്തിന്റെ ചിത്രം */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
      </Helmet>
    <div className="min-h-screen bg-gray-50 pb-24">
      
      {/* ⚠️ ശ്രദ്ധിക്കുക: ഹെഡർ (Navbar) ഇനി App.js-ൽ കൊടുക്കുന്നതാണ് നല്ലത് 
          അതുകൊണ്ട് ഈ ഫയലിൽ നിന്ന് ഹെഡർ ഒഴിവാക്കി. */}

      {/* HERO IMAGE */}
      <div className="relative w-full h-[40vh] md:h-[50vh] bg-gray-900">
        <motion.img 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          src={place.image}
          alt={place.name}
          className="w-full h-full object-cover opacity-90" 
        />
        
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40 to-transparent"></div>
        
        {/* ഈ ടൂറിസം പേജ് ഷെയർ ചെയ്യാനുള്ള ബട്ടൺ ഇമേജിന്റെ വലത്ത് മുകളിൽ കൊടുക്കാം */}
        <div className="absolute top-4 right-4 z-10">
           <ShareButton 
            title={place.name} 
            text={`INFO PAYANGADI: ${place.name}-നെ കുറിച്ചുള്ള കൂടുതൽ വിവരങ്ങൾ വായിക്കാം`} 
            url={window.location.href} 
          />
        </div>

        <div className="absolute bottom-16 left-0 right-0 px-6 md:px-12">
          <motion.h1 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="text-4xl md:text-5xl font-extrabold text-white mb-3 tracking-tight drop-shadow-lg"
          >
            {place.name}
          </motion.h1>
          
          <motion.div 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.5 }}
            className="inline-flex items-center gap-1.5 bg-white/20 backdrop-blur-md px-4 py-1.5 rounded-full text-white text-sm font-semibold border border-white/30 shadow-sm"
          >
            <MapPin size={16} /> 
            <span>{place.location}</span>
          </motion.div>
        </div>
      </div>

      {/* CONTENT SECTION */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8 -mt-10 relative z-10">
        <motion.div 
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          className="bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-shadow duration-300 border border-gray-100 p-6 md:p-10 mb-8"
        >
          <div className="w-16 h-1.5 bg-gradient-to-r from-blue-600 to-cyan-400 rounded-full mb-8"></div>
          
          <p className="text-gray-700 leading-relaxed whitespace-pre-line text-base md:text-[1.05rem] first-letter:text-5xl first-letter:font-black first-letter:text-blue-600 first-letter:mr-2 first-letter:float-left first-letter:-mt-1 first-letter:drop-shadow-sm">
            {place.fullDesc}
          </p>
          
        </motion.div>
      </div>

    </div>
    </>
  );
}